import { AlertColor, SxProps } from "@mui/material";

import { useState } from "react";
import { SnackbarInfo } from "../type";

export function useSnackbar() {
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarInfo, setSnackbarInfo] = useState<SnackbarInfo>({
    severity: undefined,
    message: "",
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
  });

  const handleSnackbarOpen = (
    severity: AlertColor,
    message: string,
    options: {
      sx?: SxProps;
      anchorOrigin?: SnackbarInfo["anchorOrigin"];
    } = {},
    duration: number = 3000
  ) => {
    setSnackbarOpen(true);

    if (Object.keys(options).length) {
      setSnackbarInfo({
        severity: severity,
        message: message,
        // sx: options.sx || {},
        anchorOrigin: options.anchorOrigin || {
          vertical: "bottom",
          horizontal: "left",
        },
        duration: duration ? duration : 3000,
      });
    } else {
      setSnackbarInfo({
        severity: severity,
        message: message,
        // sx: {},
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        duration: duration ? duration : 3000,
      });
    }
  };

  // const graySnackbarOpen = (message: string) => {
  //   handleSnackbarOpen("error", message, {
  //     sx: {
  //       backgroundColor: backgroundColors.disabled,
  //       color: textColors.sub,
  //       border: `1px solid ${borderColors.hover}`,
  //     },
  //     anchorOrigin: { vertical: "top", horizontal: "center" },
  //   });
  // };

  // const greenSnackbarOpen = (message: string) => {
  //   handleSnackbarOpen("success", message, {
  //     sx: {
  //       width: "440px",
  //       backgroundColor: greenColors[100],
  //       color: greenColors.main,
  //       border: `1px solid ${greenColors.main}`,
  //     },
  //     anchorOrigin: { vertical: "top", horizontal: "center" },
  //   });
  // };

  const handleSnackbarClose = (_: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  return {
    snackbarOpen,
    snackbarInfo,
    handleSnackbarOpen,
    handleSnackbarClose,
    // graySnackbarOpen,
    // greenSnackbarOpen,
  };
}
